<div class="flex flex-middle">
  <!-- sort by -->
  <span class="col-12 p-r-1 no-wrap"
  sizeClass="S: p2, !S: p1">{{'Sort by' | translate}}:</span>

  <!-- select -->
  <div class="pos-relative col-1"
    (offClick)="open = false"
    [offClickOff]="!open">
    <div class="flex flex-middle cursor-pointer p-l-1 p-r-1 p-t-1 p-b-1 b-a"
      [class.b-col-w]="!open"
      (click)="open = !open"
      [ngStyle]="{'width' : app.client.isS ? '7rem' : '8rem'}">
      <span class="flex-grow lh-1 m-r-2"
        sizeClass="S: p2, !S: p1"
      [class.isOpen]="open">{{sort.selectionLabel}}</span>
      <i class="fs-2"
        [class.icon-arrow-down]="!open"
      [class.icon-arrow-up]="open"></i>
    </div>
    <div class="pos-absolute left-0 right-0 w-12 z-10 bg-col-w">
      <div class="hide-up-container">
        <div class="ng-hide-animate ng-hide hide-up"
          [class.ng-hide]="!open">
          <div class="pos-relative b-a b-t-0 b-col-4 cursor-pointer">
            @for (option of sort.getOptions(); track $index; let isLast = $last) {
              <div class="p-t-1 p-b-1 p-l-2 p-r-2 lh-2"
                [ngClass]="{'b-b b-col-4': !isLast}">
                <span sizeClass="S: p2, !S: p1"
                (click)="sort.by(option); open = false;">{{option.label}}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>